import { DuplicateContactException } from './CustomErrors';

const phoneErrorCodes = error => {
  const codes = error?.errors?.phone_number;
  return Array.isArray(codes) ? codes : [];
};

const hasPhoneAttribute = error =>
  error instanceof DuplicateContactException &&
  error.data?.includes?.('phone_number');

export const isDuplicatePhoneError = error => {
  if (!hasPhoneAttribute(error)) return false;

  const codes = phoneErrorCodes(error);
  if (codes.length) {
    return codes.includes('taken') && !codes.includes('invalid');
  }

  const message = error.validationMessage || '';
  return /already been taken/i.test(message) && !/e164/i.test(message);
};

export const isInvalidPhoneError = error => {
  if (!hasPhoneAttribute(error)) return false;

  const codes = phoneErrorCodes(error);
  if (codes.includes('invalid')) return true;
  if (codes.length) return false;

  return /e164/i.test(error.validationMessage || '');
};
